const setList = (state, payload) => {
  state.list = payload
}

const setLoading = (state, payload) => {
  state.loading = payload
}

const turnTag = (state, clickedTag) => {
  state.list.forEach(tag =>
    tag.active = tag.id === clickedTag.id ? !tag.active : tag.active
  )
}

export default {
  setList,
  setLoading,
  turnTag,
}
